import { useMutation } from '@tanstack/react-query';
import { useAuth } from './useAuth';
import { LoginDto, AuthResponseData } from '../services/api/auth.types';
import { parseApiErrorMessage } from '../services/api/api';

export function useLogin() {
  const { login } = useAuth();

  return useMutation<AuthResponseData, Error, LoginDto>({
    mutationFn: async (dto: LoginDto) => {
      try {
        return await login(dto);
      } catch (err) {
        const errorMsg = parseApiErrorMessage(err);
        throw new Error(errorMsg);
      }
    },
  });
}
